
<div  (mouseup)="scrollToTop()" id="arrow" role="button" aria-label="Przycisk przenoszący na początek strony" tabindex="0"
class="angryArrow WCAG_con_Title WCAG_con_white">
<img src="../../../../assets/icon/arrow.svg" alt="Strzałka w górę" aria-hidden="true" >
</div>
